import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

import Popper from "components/Popper";

export function FilterLabel({ isSynced, name, syncDesc, ...props }) {
  return (
    <div {...props}>
      {isSynced}
      {name}
      {isSynced && (
        <Popper
          on="hover"
          content={syncDesc}
          trigger={
            <Icon
              name="info circle"
              color="grey"
              size="small"
              style={{
                paddingLeft: "0.4rem",
                fontSize: "1.0em",
              }}
            />
          }
        />
      )}
    </div>
  );
}

FilterLabel.propTypes = {
  isSynced: PropTypes.node,
  name: PropTypes.string,
  syncDesc: PropTypes.string,
};

FilterLabel.defaultProps = {
  isSynced: undefined,
  name: "",
  syncDesc: "This list of users is managed by your CRM",
};

export default FilterLabel;
